export const DialogsActions = {
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  CLOSE_DIALOG_WITH_DATA: 'CLOSE_DIALOG_WITH_DATA',
} as const;

export const openDialogAction = (payload: { name: string; data?: any }) => ({
  type: DialogsActions.OPEN_DIALOG,
  payload,
});

export const closeDialogAction = (payload: string) => ({
  type: DialogsActions.CLOSE_DIALOG,
  payload,
});

export const closeDialogWithDataAction = (payload: { name: string; data?: any }) => ({
  type: DialogsActions.CLOSE_DIALOG_WITH_DATA,
  payload,
});

export const dialogsActions = {
  openDialogAction,
  closeDialogAction,
  closeDialogWithDataAction,
};
